import { Input } from "@/components/ui/input";

// Campo de formulário com ícone, usado nas telas de autenticação.
export const IconField = ({ id, icon: Icon, label, hint, className = "", children, ...inputProps }) =>
  <div className="space-y-1.5">
    <div className="flex items-center justify-between">
      <label htmlFor={id} className="text-sm font-medium text-foreground/80">{label}</label>
      {children}
    </div>
    <div className="relative">
      <Icon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
      <Input id={id} className={`pl-10 h-12 bg-card border-border focus-visible:ring-primary ${className}`} {...inputProps} />
    </div>
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>;

export const FormAlert = ({ message, testId }) => message
  ? <div role="alert" data-testid={testId} className="p-3.5 rounded-xl bg-destructive/10 border border-destructive/30 text-destructive text-sm break-words">{message}</div>
  : null;
